import { useNostrPublish } from './useNostrPublish';
import { useQueryClient } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

export function useDeleteEvent() {
  const { mutateAsync: publish } = useNostrPublish();
  const queryClient = useQueryClient();

  const deleteEvent = async (event: NostrEvent) => {
    await publish({
      kind: 5,
      content: '',
      tags: [
        ['e', event.id],
        ['a', `${event.kind}:${event.pubkey}:${event.tags.find(([n]) => n === 'd')?.[1] ?? ''}`],
      ],
    });

    // Invalidate relevant queries
    queryClient.invalidateQueries({ queryKey: ['nostr', 'link-lists'] });
    queryClient.invalidateQueries({ queryKey: ['nostr', 'link-list'] });
  };

  return { deleteEvent };
}
